export default __webpack_public_path__ + "static/media/right.12e25587.png";